module.exports = __webpack_public_path__ + "img/avatar-6.1b5b3cd6.jpg";